import { InstallSpec, ItemComponent } from "../../../install/types.ts";

export const WindowsComponents = InstallSpec({
  "iam-write": ItemComponent({
    type: "dynamic",
    label: "Windows access control",
    description: "Allows P0 to provide access to Windows users",
    maturity: "preview",
    schema: {},
  }),
});
